export interface IRETIREMENT_FORMULA {
  currentAge: number;
  retirementAge: number;
  expectedAge: number;
  monthlyIncome: number;
  expectedInflation: number;
  roiPre: number;
  roiPost: number;
  existingSaving: string;
  existingRetirementFunds: number;
}
export const RETIREMENT_FORMULA = ({
  currentAge,
  retirementAge,
  expectedAge,
  monthlyIncome,
  expectedInflation,
  roiPre,
  roiPost,
  existingSaving,
  existingRetirementFunds,
}: IRETIREMENT_FORMULA) => {
  const currAge = Number(currentAge);
  const retireAge = Number(retirementAge);
  const expectAge = Number(expectedAge);
  const monthlyInc = Number(monthlyIncome);
  const inflationRate = Number(expectedInflation);
  const returnPre = Number(roiPre);
  const returnPost = Number(roiPost);
  const saving = String(existingSaving);
  let savedfunds = 0;
  if (saving == 'YES') savedfunds = Number(existingRetirementFunds);
  else savedfunds = 0;
  if (
    currAge < 15 ||
    currAge > 60 ||
    retireAge < 15 ||
    retireAge > 70 ||
    retireAge < currAge ||
    expectAge < 30 ||
    expectAge > 100 ||
    expectAge < retireAge ||
    monthlyInc < 1 ||
    monthlyInc > 1e9 ||
    inflationRate < 1 ||
    inflationRate > 40 ||
    returnPre < 0 ||
    returnPre > 60 ||
    returnPost < 0 ||
    returnPost > 30 ||
    savedfunds < 0 ||
    savedfunds > 1e10
  ) {
    const res = 0;
    return {
      annualIncomeRequired: res,
      addtionalFundsNeeded: res,
      monthlySavingsNeeded: res,
      msg: '',
    };
  }
  const reqAnnual = monthlyInc * 12;
  const yearsRetire = retireAge - currAge;
  const yearsProvide = expectAge - retireAge;
  //((1+(roiPost/100))/(1+(expectedInflation/100))-1)*100
  const discountFactor =
    ((1 + returnPost / 100) / (1 + inflationRate / 100) - 1) * 100;

  //'round(requiredAnnual*(1+(expectedInflation/100))^yearsToRetirement,0)',

  const incReq = Math.round(
    reqAnnual * Math.pow(1 + inflationRate / 100, yearsRetire)
  );
  //-FV(roiPre / 100, yearsToRetirement, 0, existingRetirementFunds);

  const fv = savedfunds * Math.pow(1 + returnPre / 100, yearsRetire);
  const rate = discountFactor / 100;
  const pv =
    rate === 0
      ? incReq * yearsProvide
      : -(
          (((1 - Math.pow(1 + rate, yearsProvide)) / rate) * incReq) /
          Math.pow(1 + rate, yearsProvide)
        );

  const positive = Math.round(pv - fv);
  const additionFunds = positive > 0 ? positive : 0;

  //'round(-PMT((roiPre/1200),yearsToRetirement*12,0,addtionalFundsNeeded),0)',
  const term = Math.pow(1 + returnPre / 1200, yearsRetire * 12);
  const monthlyPayment = Math.round(
    (additionFunds * returnPre) / 1200 / (term - 1)
  );

  const msg =
    "You're Doing Well! You Can Continue Investing In Mutual Fund For More Wealth";
  return {
    annualIncomeRequired: incReq,
    addtionalFundsNeeded: additionFunds,
    monthlySavingsNeeded: monthlyPayment,
    msg: monthlyPayment < 1 ? '' : msg,
  };
};
